import { getAbnormalDocument, getUserBlowDep, setUserBlowDep, } from '../services/index';
import { reqExpenseType } from '@/routes/Apply/services';

export default {
  namespace: 'abnormalDocument',
  state: {},
  effects: {
    * GetAbnormalDocument ({ payload }, { call }) {
      return yield call(getAbnormalDocument, payload);
    },

    * GetUserBlowDep ({ payload }, { call }) {
      return yield call(getUserBlowDep, payload);
    },

    * SetUserBlowDep ({ payload }, { call }) {
      return yield call(setUserBlowDep, payload);
    },

    * GetCommonDic ({ payload }, { call }) {
      return yield call(reqExpenseType, payload);
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
